import { useEffect } from "react";
import { toast } from "sonner";
import { drinkSound } from "./audio";

const LINES = [
  "Joe takes a quick drink from his flask.",
  "Joe unscrews the flask and takes a long pull. It burns all the way down.",
  "A sip from the flask. Just to take the edge off.",
  "Joe takes a drink. The cold doesn't bite quite as hard.",
  "Joe's hand finds the flask again. One more sip.",
  "Joe takes a swig from the flask and wipes his mouth on his sleeve.",
];

const PHOTO_LINES = [
  "In the quiet, Joe takes Lily's worn photo out of his wallet. Her gap-toothed grin. He puts it away before anyone sees.",
  "Joe looks at Lily's photo again. The corners have gone soft from handling. 'Best day ever,' it says on the back.",
  "For a moment Joe just holds the photo. Lily and her fish. The lake was so bright that day.",
];

export const useFlask = ({ pausedRef, menuRef, engineRef, onDrink }) => {
  useEffect(() => {
    let next = Date.now() + 60000 + Math.random() * 40000;
    const id = setInterval(() => {
      const st = engineRef.current;
      if (!st || pausedRef.current || menuRef.current || st.cutscene || st.scene || st.pending || Date.now() < next) return;
      next = Date.now() + 90000 + Math.random() * 90000;
      drinkSound(); onDrink();
      toast(LINES[Math.floor(Math.random() * LINES.length)], { duration: 3500, className: "italic" });
    }, 1000);
    let still = 0, nextPhoto = Date.now() + 45000;
    const photo = setInterval(() => {
      const st = engineRef.current;
      if (!st || st.moving || pausedRef.current || menuRef.current || st.cutscene || st.scene || st.pending) { still = 0; return; }
      still += 1;
      if (still < 20 || Date.now() < nextPhoto) return;
      still = 0; nextPhoto = Date.now() + 150000 + Math.random() * 90000;
      toast(PHOTO_LINES[Math.floor(Math.random() * PHOTO_LINES.length)], { duration: 6000, className: "italic" });
    }, 1000);
    return () => { clearInterval(id); clearInterval(photo); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pausedRef, menuRef, engineRef]);
};
